import React from "react";
import { Star } from "@phosphor-icons/react";
import { useAdminMode } from "../../context/AdminModeContext";

/** Subtle, owner-only signal that President mode is active.
 * Appears in the upper-left as a pulsing gold star + "OWNER MODE" wordmark
 * in a futuristic typeface (Orbitron — already wired via Google Fonts). */
export default function OwnerModeIndicator() {
  const { isPresident } = useAdminMode();
  if (!isPresident) return null;
  return (
    <div
      className="fixed top-3 left-3 z-[55] pointer-events-none select-none flex items-center gap-2 px-3 py-1.5 rounded-full bg-black/35 backdrop-blur-md border border-amber-300/30"
      data-testid="owner-mode-indicator"
      style={{ fontFamily: "'Orbitron', 'Inter', sans-serif" }}
    >
      <span className="relative inline-flex">
        <Star size={16} weight="fill" className="text-amber-300 owner-star-flutter" />
        <span className="absolute inset-0 owner-star-glow rounded-full" aria-hidden="true" />
      </span>
      <span className="text-[10px] tracking-[0.35em] uppercase font-bold text-amber-300/90 owner-text-pulse">
        Owner Mode
      </span>
    </div>
  );
}
